/* This file is autogenerated, see readme.md for instructions */
import PagesSvgIcon from '@bloomreach/banana-theme/icons/pages.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const PagesIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <PagesSvgIcon />
    </Icon>
  );
});

PagesIcon.displayName = 'PagesIcon';

export default PagesIcon;
